'use client'

import { parseAsString, useQueryState } from 'nuqs'

const templateSearchQueryParser = parseAsString.withDefault('')

/**
 * Persisted semantic query (`q`) for /templates, /browse/templates, and
 * /explore. Shallow so keystrokes do not remount cached gallery loaders.
 */
export function useTemplateSearchQuery() {
  return useQueryState(
    'q',
    templateSearchQueryParser.withOptions({
      shallow: true,
      clearOnDefault: true,
    })
  )
}
